// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"614":"0353f63da8cae857ae2f","973":"07f130efa2364e443407"}[chunkId] + ".js";
};